module.exports = __webpack_public_path__ + "img/yidong1.bbbd3e00.png";